import { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { SpinnerGrey } from '../../components/stories/atoms/icons/special'
import { LoaderContainer } from './styled-component'
import { iconSizeOptions } from '../../components/stories/atoms/icons/icons-sizes'
import { modeOptions } from '../authentication/constants'
import { useLoginVerifyEmailMutation } from '../../react-query/authentication/mutation/use-login-verify-email-mutation'

const ChangeEmailVerification = () => {
  const params = useParams()
  const history = useHistory()

  const onVerifySuccess = () => {
    history.push(`/home/${modeOptions.EMAIL_VERIFICATION_SUCCESS}`)
  }

  const onVerifyError = () => {
    history.push(`/home/${modeOptions.EMAIL_VERIFICATION_FAILED}`)
  }

  const { mutate: handleVerifyEmail, isPending: verifyEmailLoading } =
    useLoginVerifyEmailMutation({
      onSuccess: onVerifySuccess,
      onError: onVerifyError
    })

  useEffect(() => {
    if (params?.mode === 'verifyEmail' && params?.token) {
      handleVerifyEmail({ token: params.token })
    }
  }, [])

  if (verifyEmailLoading) {
    return (
      <LoaderContainer>
        <SpinnerGrey size={iconSizeOptions['ICON-XL']} />
      </LoaderContainer>
    )
  }

  return null
}

export default ChangeEmailVerification
